import { render, staticRenderFns } from "./hotGamePushVertical.vue?vue&type=template&id=fed5b282&scoped=true&"
import script from "./hotGamePushVertical.vue?vue&type=script&lang=js&"
export * from "./hotGamePushVertical.vue?vue&type=script&lang=js&"
import style0 from "./hotGamePushVertical.vue?vue&type=style&index=0&id=fed5b282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed5b282",
  null
  
)

export default component.exports